import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { FormComponent } from 'src/domains/layouts/shared/cms/form/Form.style';
import { SectionHeaderComponent } from 'src/main/cms/Sports/SportsForm/SectionHeader';
import { CustomizedSportsState } from 'src/AppState/CmsState/SportsState/SportsState';
import { SportsHeaderForm } from './SportsHeaderForm';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { SportsFilters } from './SportsFilters/SportsFilters';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';
import { Select } from 'src/domains/layouts/shared/formComponents/Select/components/new/Select';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

interface PropsTypes {
    sportState: CustomizedSportsState,
}

export const ExistingSportsForm = observer('ExistingSportsForm', ({ sportState }: PropsTypes) => {
    const {
        sportSlug,
        sportLabel,
        sportListOptions,
        handleCreate,
        handleResetForm,
        handleEdit,
        handleSportSelect,
        isOpenSections,
        isEditMode,
        isLoading,
        isSportSelected
    } = sportState;

    return (
        <>
            {sportSlug.value === '' ? null : <Label>Sport slug: {sportSlug.value}</Label>}
            <FormComponent onSubmit={(e: React.FormEvent<HTMLFormElement>): void => {
                e.preventDefault();
            }}>
                <Loader isActive={isLoading}/>

                {isEditMode ? null :
                    <Select
                        placeholder='Select sport'
                        stateValue={sportSlug}
                        selectOptions={sportListOptions}
                        onChangeCB={handleSportSelect}
                        dataTest='select-existing-sport'
                    />}

                {isSportSelected === false ? null :
                    <>
                        <Input
                            label='Custom sport label'
                            formInputState={sportLabel}
                            dataTest='select-existing-sport-label'
                        />
                        <SectionHeaderComponent label='Sport Header' sectionType='sportHeader' sportState={sportState} />
                        {isOpenSections.sportHeader ? <SportsHeaderForm sportState={sportState} /> : null}
                        <SectionHeaderComponent label='Custom filters' sectionType='customFilters' sportState={sportState} />
                        {isOpenSections.customFilters ? <SportsFilters sportState={sportState} /> : null}

                        {/* Upload scoreboard background images and change color text */}
                        {/* <ScoreboardsForm sportState={sportState} /> */}
                    </>
                }
            </FormComponent>

            <FormButtons
                onCreate={handleCreate}
                onUpdate={handleEdit}
                onCancel={handleResetForm}
                dataTestCancel='customize-sport-cancel'
                dataTestCreate='customize-sport-create'
                dataTestUpdate='customize-sport-update'
                isEditMode={isEditMode}
            />
        </>
    );
});


